import React from "react";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
import KnowMore from "@/components/ui/know-more";

export default function News({ press, title, className = "bg-[#F6F5F1]" }) {
  const breakpoints = {
    1280: {
      slidesPerView: 3.4,
      spaceBetween: 40,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    991: {
      slidesPerView: 2.4,
      spaceBetween: 30,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2.1,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 1.1,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <div className="flex flex-col w-full">
      <div
        className={`md:py-16 pt-8 pb-16 relative z-[100] flex flex-col items-center ${className}`}
      >
        <Carousel
          slidesPerView={3.4}
          spaceBetween={40}
          loop={true}
          className="featureCarousel w-full my-8"
          breakpoints={breakpoints}
          navigation={true}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          // mousewheel={{
          //   forceToAxis: true,
          //   sensitivity: 1,
          //   releaseOnEdges: true,
          // }}
          title={title}
        >
          {press.map((publication, key) => (
            <SwiperSlide key={"feature" + key}>
              <Card data={publication} key={"publication" + key} />
            </SwiperSlide>
          ))}
        </Carousel>
        <KnowMore path="/media#publications" className="mx-auto mt-12">
          View More
        </KnowMore>
      </div>
    </div>
  );
}

const Card = ({ data }) => {
  const { publicationTitle, publication, image, logo, link, author } = data;
  return (
    <div className="flex flex-col w-full">
      <a
        href={link ?? "#"}
        target="_blank"
        rel="nofollow"
        className={`flex items-start justify-start relative w-full 2xl:h-[20vw] md:h-[295px] h-[295px] overflow-hidden mb-4`}
      >
        <Image
          src={image?.data?.attributes?.url ?? "/images/placeholder.svg"}
          alt={publication}
          sizes="(max-width: 479px) 500px, 1000px"
          fill
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center bg-black/30  backdrop-blur-[2px] overflow-hidden">
          <div className="md:w-[300px] md:h-[300px] w-[250px] h-[250px] flex flex-col items-center justify-center relative">
            <Image
              src={logo?.data?.attributes?.url ?? "/images/placeholder.svg"}
              alt={publicationTitle}
              fill
              sizes="(max-width: 479px) 500px, 500px"
              className="object-contain p-4"
            />
          </div>
        </div>
      </a>
      <p className="text-sm text-[#121111]/60 mb-1">
        {author} | {publication}
      </p>
      <span className="text-[#121111]/90 lg:text-lg text-base !leading-tight">
        {publicationTitle}
      </span>
    </div>
  );
};

// const Believe = ({params}) =>{
//     const {}
// }
